import React from 'react';
import * as Sentry from '@sentry/browser';

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const APP_ENV = process.env.REACT_APP_ENV;
const APP_VERSION = process.env.REACT_APP_VERSION;

const WithSentry = (Children) => {
  // eslint-disable-next-line
    class withSentry extends React.Component {
    constructor(props) {
      super(props);
      Sentry.init({
        dsn: SENTRY_DSN,
        environment: APP_ENV,
        release: APP_VERSION,
      });
    }

    render() {
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <Children {...this.props} />;
    }
  }
  withSentry.displayName = 'SentryHOC';
  return withSentry;
};

export default WithSentry;
